var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganisationlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58332 12.8923H2.91666C1.74999 12.8923 1.16666 12.3089 1.16666 11.1423V6.47559C1.16666 5.30892 1.74999 4.72559 2.91666 4.72559M7.58332 12.8923C6.41666 12.8923 5.83332 12.3089 5.83332 11.1423M7.58332 12.8923H11.0833C12.25 12.8923 12.8333 12.3089 12.8333 11.1423V2.97559C12.8333 1.80892 12.25 1.22559 11.0833 1.22559H7.58332C6.41666 1.22559 5.83332 1.80892 5.83332 2.97559M2.91666 4.72559H5.83332M2.91666 4.72559V3.55892C2.91666 2.91725 3.44166 2.39225 4.08332 2.39225H5.89748C5.85081 2.56725 5.83332 2.75975 5.83332 2.97559M5.83332 4.72559V11.1423M5.83332 4.72559V2.97559M5.83332 11.1423V2.97559M8.16666 4.72559V7.64225M10.5 4.72559V7.64225M3.49999 7.64225V9.97559M9.91666 9.97559H8.74999C8.42916 9.97559 8.16666 10.2381 8.16666 10.5589V12.8923H10.5V10.5589C10.5 10.2381 10.2375 9.97559 9.91666 9.97559Z",
    stroke: "#3E3E3E",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganisationlogo);
export default __webpack_public_path__ + "static/media/organisationlogo.3da9cd45263a88752486d0a53d674050.svg";
export { ForwardRef as ReactComponent };